// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:frontend-models` to regenerate.
import FrontendModelBase from "velocious/build/src/frontend-models/base.js"

/**
 * Frontend model resource config.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelResourceConfig} FrontendModelResourceConfig
 */
/**
 * Fallback attribute value type for generated fields without narrower metadata.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelAttributeValue} FrontendModelAttributeValue
 */

/**
 * UserAuthTokenAttributes type.
 * @typedef {object} UserAuthTokenAttributes
 * @property {Date | null} createdAt - Attribute value.
 * @property {string} id - Attribute value.
 * @property {Date | null} lastUsedAt - Attribute value.
 * @property {string} name - Attribute value.
 * @property {string} tokenPrefix - Attribute value.
 * @property {Date | null} updatedAt - Attribute value.
 * @property {string} userId - Attribute value.
 */
/**
 * Attributes accepted by UserAuthTokenCreateAttributes.
 * @typedef {object} UserAuthTokenCreateAttributes
 * @property {UserAuthTokenAttributes["name"] | null} [name] - Permitted name value.
 */
/**
 * Attributes accepted by UserAuthTokenUpdateAttributes.
 * @typedef {object} UserAuthTokenUpdateAttributes
 * @property {UserAuthTokenAttributes["name"] | null} [name] - Permitted name value.
 */
/**
 * Frontend model for UserAuthToken.
 * @augments {FrontendModelBase<UserAuthTokenAttributes, UserAuthTokenCreateAttributes, UserAuthTokenUpdateAttributes, UserAuthTokenAttributes["id"], string>}
 */
class UserAuthToken extends FrontendModelBase {
  /** @returns {FrontendModelResourceConfig} - Resource config. */
  static resourceConfig() {
    return {
      modelName: "UserAuthToken",
      attributes: [
        "createdAt",
        "id",
        "lastUsedAt",
        "name",
        "tokenPrefix",
        "updatedAt",
        "userId",
      ],
      collectionCommands: [
        "generate",
      ],
    }
  }

  /** @returns {Record<string, {type: "belongsTo" | "hasOne" | "hasMany", autoload?: boolean}>} - Relationship definitions. */
  static relationshipDefinitions() {
    return {
      user: {type: "belongsTo"},
    }
  }

  /** @returns {Record<string, string>} - Relationship model class names. */
  static relationshipModelClasses() {
    return {
      user: "User",
    }
  }

  /** @returns {UserAuthTokenAttributes["createdAt"]} - Attribute value. */
  createdAt() { return /** @type {UserAuthTokenAttributes["createdAt"]} */ (this.readAttribute("createdAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setCreatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("createdAt", newValue)) }

  /** @returns {UserAuthTokenAttributes["id"]} - Attribute value. */
  id() { return /** @type {UserAuthTokenAttributes["id"]} */ (this.readAttribute("id")) }

  /**
   * @param {UserAuthTokenAttributes["id"] | null} newValue - New attribute value.
   * @returns {UserAuthTokenAttributes["id"] | null} - Assigned value.
   */
  setId(newValue) { return /** @type {UserAuthTokenAttributes["id"] | null} */ (this.setAttribute("id", newValue)) }

  /** @returns {UserAuthTokenAttributes["lastUsedAt"]} - Attribute value. */
  lastUsedAt() { return /** @type {UserAuthTokenAttributes["lastUsedAt"]} */ (this.readAttribute("lastUsedAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setLastUsedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("lastUsedAt", newValue)) }

  /** @returns {UserAuthTokenAttributes["name"]} - Attribute value. */
  name() { return /** @type {UserAuthTokenAttributes["name"]} */ (this.readAttribute("name")) }

  /**
   * @param {UserAuthTokenAttributes["name"] | null} newValue - New attribute value.
   * @returns {UserAuthTokenAttributes["name"] | null} - Assigned value.
   */
  setName(newValue) { return /** @type {UserAuthTokenAttributes["name"] | null} */ (this.setAttribute("name", newValue)) }

  /** @returns {UserAuthTokenAttributes["tokenPrefix"]} - Attribute value. */
  tokenPrefix() { return /** @type {UserAuthTokenAttributes["tokenPrefix"]} */ (this.readAttribute("tokenPrefix")) }

  /**
   * @param {UserAuthTokenAttributes["tokenPrefix"] | null} newValue - New attribute value.
   * @returns {UserAuthTokenAttributes["tokenPrefix"] | null} - Assigned value.
   */
  setTokenPrefix(newValue) { return /** @type {UserAuthTokenAttributes["tokenPrefix"] | null} */ (this.setAttribute("tokenPrefix", newValue)) }

  /** @returns {UserAuthTokenAttributes["updatedAt"]} - Attribute value. */
  updatedAt() { return /** @type {UserAuthTokenAttributes["updatedAt"]} */ (this.readAttribute("updatedAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setUpdatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("updatedAt", newValue)) }

  /** @returns {UserAuthTokenAttributes["userId"]} - Attribute value. */
  userId() { return /** @type {UserAuthTokenAttributes["userId"]} */ (this.readAttribute("userId")) }

  /**
   * @param {UserAuthTokenAttributes["userId"] | null} newValue - New attribute value.
   * @returns {UserAuthTokenAttributes["userId"] | null} - Assigned value.
   */
  setUserId(newValue) { return /** @type {UserAuthTokenAttributes["userId"] | null} */ (this.setAttribute("userId", newValue)) }

  /**
   * Runs generate.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{authToken: {createdAt: Date | null, id: string | number, lastUsedAt: Date | null, name: string, tokenPrefix: string}, token: string}>} - Command response.
   */
  static async generate(...commandArguments) {
    return /** @type {{authToken: {createdAt: Date | null, id: string | number, lastUsedAt: Date | null, name: string, tokenPrefix: string}, token: string}} */ (await this.executeCustomCommand({
      commandName: "generate",
      commandType: "generate",
      payload: UserAuthToken.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Returns user relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<UserAuthToken, import("./user.js").User, import("./user.js").UserCreateAttributes>} - Relationship helper.
   */
  userRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<UserAuthToken, import("./user.js").User, import("./user.js").UserCreateAttributes>} */ (this.getRelationshipByName("user")) }

  /**
   * Returns user.
   * @returns {import("./user.js").User | null} - Loaded related model.
   */
  user() { return this.userRelationship().loaded() }

  /**
   * Builds user.
   * @param {import("./user.js").UserCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./user.js").User} - Built related model.
   */
  buildUser(attributes = {}) { return this.userRelationship().build(attributes) }

  /**
   * Loads user.
   * @returns {Promise<import("./user.js").User | null>} - Loaded related model.
   */
  async loadUser() { return await this.userRelationship().load() }

  /**
   * Returns or loads user.
   * @returns {Promise<import("./user.js").User | null>} - Loaded related model.
   */
  async userOrLoad() { return await this.userRelationship().orLoad() }

  /**
   * Sets user.
   * @param {import("./user.js").User | null} model - Related model.
   * @returns {void}
   */
  setUser(model) { this.userRelationship().setLoaded(model) }

  /**
   * Registers a class-level destroy callback.
   * @overload
   * @param {(payload: {id: string}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * @template {import("velocious/build/src/frontend-models/base.js").FrontendModelClass} T
   * @overload
   * @this {T}
   * @param {(payload: {id: import("velocious/build/src/frontend-models/base.js").FrontendModelEventPrimaryKeyValueFor<InstanceType<T>>}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * Implements class-level destroy callback registration.
   * @param {(payload: {id: never}) => void} callback - Type-erased event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  static async onDestroy(callback, options = {}) {
    return await this._registerDestroyEventCallback(callback, options)
  }
}

FrontendModelBase.registerModel(UserAuthToken)

export {UserAuthToken}

export default UserAuthToken
